module.exports = __webpack_public_path__ + "static/images/dialog-gift-btn.c57e13a.png";